import { Button, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { LOGIN } from "../../../global/urlMapping";
import { Redirect } from "../../tools/Redirect";
import { AuthComp } from "../../../auth/AuthComp";
import { postAppointmentCancelAction } from "../../../modules/screening/actions";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getDeclineReasonsCLAction } from "../../../modules/screeningColonRetto/actions";
import { declineReasonsCLSelector } from "../../../modules/screeningColonRetto/selectors";

export const RifiutoCL = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const declineReasonsCL = useSelector(declineReasonsCLSelector);

    const [reasonSelected, setReasonSelected] = useState(null);
    const [atLeastOne, setAtLeastOne] = useState(false);
    const invite = location?.state?.invite

    const handleChange = (event) => {
        setAtLeastOne(event.target.checked);
        setReasonSelected(event.target.value);
    };

    const onClickConferma = () => {
        dispatch(postAppointmentCancelAction({
            "idAppointment": invite?.id,
            "cancelReasonCode": reasonSelected
        }))
    }

    useEffect(() => {
        dispatch(getDeclineReasonsCLAction())
    }, [dispatch])

    useEffect(() => {
        if (invite === undefined || invite === null)
            navigate(-1)
    }, [invite, navigate])
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <AuthComp fallback={<Redirect link={LOGIN} />} >
            <Box
                sx={{
                    width: "100%",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: "200px"
                }}
            >
                <Box sx={{ height: "150px", width: "100%", display: "flex" }}>
                    <Typography
                        sx={{
                            color: "#005397",
                            fontSize: "25px",
                            fontWeight: 700,
                            textAlign: "center",
                            margin: "auto",
                        }}
                    >
                        Indica per quale motivo preferisci non aderire alla campagna di screening
                    </Typography>
                </Box>
                <Box
                    sx={{
                        height: "auto",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <FormControl sx={{ height: "auto", width: "100%", margin: "auto" }}>
                        <RadioGroup
                            sx={{ height: "auto", width: "100%", display: "flex" }}
                            onChange={handleChange}
                        >
                            {
                                declineReasonsCL?.value && declineReasonsCL?.value.map((element, index) => (
                                    <FormControlLabel
                                        sx={{
                                            height: "auto",
                                            width: { xs: "300px", md: "300px", lg: "700px" },
                                            backgroundColor: "transparent",
                                            margin: "auto",
                                            marginTop: "30px",
                                            borderBottom: element.declineReasonCode !== "623" ? "1px solid #005397" : "0px",
                                        }}
                                        key={index}
                                        value={element.declineReasonCode}
                                        control={<Radio sx={{ color: "#005397" }} />}
                                        labelPlacement="start"
                                        label={

                                            <Typography
                                                sx={{
                                                    width: { xs: "200px", md: "300px", lg: "600px" },
                                                    color: "#005397",
                                                    height: "auto",
                                                    fontSize: { xs: "20px", md: "25px", lg: "25px" },
                                                    fontWeight: 500,
                                                }}
                                            >
                                                {element.declineReasonDescription}
                                            </Typography>

                                        }
                                    />
                                ))
                            }
                        </RadioGroup>
                    </FormControl>
                    <Button
                        onClick={() => {
                            onClickConferma()
                        }}
                        variant="contained"
                        sx={{
                            height: { lg: "50px" },
                            width: { lg: "200px" },
                            backgroundColor: "#005397",
                            borderRadius: "20px !important",
                            margin: "30px auto",
                        }}
                        disabled={atLeastOne ? false : true}
                    >
                        Conferma
                    </Button>
                </Box>
            </Box>
        </AuthComp>
    );
};